/*
 * @Date: 2020-03-27 10:01:06
 * @LastEditors: yuanjianlong@aixuexi.com
 * @LastEditTime: 2020-04-03 18:12:01
 * @FilePath: \st-teacher-2020\src\store\modules\common.ts
 */
import S from '@/service';

interface StateClass {
  feedbackState: boolean;
  feedBackTypes: any;
  sendHomeworkDialogVisible: boolean;
  cancelSendHomeworkCallback: any;
  sendHomeworkUrl: string;
  sendHomeworkData: object;
}

const common = {
  namespaced: true,
  state: {
    feedbackState: false,
    feedBackTypes: [],
    sendHomeworkDialogVisible: false,
    cancelSendHomeworkCallback: null,
    sendHomeworkUrl: '',
    sendHomeworkData: {},
  },
  getters: {
    feedBackTypes: (state: StateClass) => state.feedBackTypes,
    feedbackState: (state: StateClass) => state.feedbackState,
    sendHomeworkDialogVisible: (state: StateClass) => state.sendHomeworkDialogVisible,
    cancelSendHomeworkCallback: (state: StateClass) => state.cancelSendHomeworkCallback,
    sendHomeworkUrl: (state: StateClass) => state.sendHomeworkUrl,
    sendHomeworkData: (state: StateClass) => state.sendHomeworkData,
  },
  mutations: {
    updateFeedBackTypes(state: StateClass, data: any) {
      state.feedBackTypes = data;
    },
    updateFeedBackState(state: StateClass, data: any) {
      state.feedbackState = data;
    },
    updateSendHomeworkDialogVisible(state: StateClass, data: any) {
      state.sendHomeworkDialogVisible = data;
    },
    updateCancelSendHomeworkCallback(state: StateClass, data: any) {
      state.cancelSendHomeworkCallback = data;
    },
    updateSendHomeworkUrl(state: StateClass, data: string) {
      state.sendHomeworkUrl = data;
    },
    updateSendHomeworkData(state: StateClass, data: object) {
      state.sendHomeworkData = data;
    },
  },
  actions: {
    // 空接口，每5分钟轮询一下接口，防止用户信息被盗用
    async maintainLogin() {
      await S.common.maintainLogin();
    },
  },
};

export default common;
